export default __webpack_public_path__ + "static/responsive-0a19b7d639df6bdfba7e4a84e80155fb.jpeg";